import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ToolService } from '@app/core/services/tool.service';
import { ModalComponent } from '@app/shared/components';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-documents-location-confirmation-modal',
    templateUrl: './documents-location-confirmation-modal.component.html',
    styleUrls: ['./documents-location-confirmation-modal.component.scss']
})
export class DocumentsLocationConfirmationModalComponent implements OnInit {
    @ViewChild(ModalComponent, {static: true}) modal: ModalComponent;

    @Output() confirm = new EventEmitter<any>();

    isLoading = false;
    paths: string[] = [];
    param: any;


    constructor(private translate: TranslateService,
                private toolService: ToolService) {
    }

    ngOnInit() {
    }

    public open(paths: string[], param = null) {
        this.modal.open();
        this.paths = paths;
        this.param = param;
    }

    public close() {
        this.modal.close();
    }

    onConfirm() {
        this.confirm.emit({
            ...this.param,
            pathsToBeRemoved: this.paths,
        });
        this.close();
    }

    onCancel() {
        this.close();
    }
}
